import { getSelectableGroupsFromStores } from '@admin/products/recipes/utils/storeGroups';

import { VARIANT_MODAL_MODE } from '../constants';

const getSelectedGroupsFromStores = (stores, fallbackGroups) => {
  if (!stores.length) {
    return [];
  }

  const selectedGroups = getSelectableGroupsFromStores(stores);

  if (selectedGroups.length) {
    return selectedGroups;
  }

  return fallbackGroups;
};

const getVariantStores = (stores, variant) => {
  const storeIds = variant?.storeIds ?? [];

  return stores.filter((store) => storeIds.includes(store.id));
};

const getMainRecipeStores = (stores, recipeVariants) => {
  const variantStoreIds = recipeVariants.reduce((result, variant) => {
    const storeIds = variant.storeIds ?? [];

    storeIds.forEach((storeId) => {
      result.add(storeId);
    });

    return result;
  }, new Set());

  return stores.filter((store) => !variantStoreIds.has(store.id));
};

export const computeInitialSelections = ({ mode, stores, recipeVariants, selectedVariant }) => {
  const groups = getSelectableGroupsFromStores(stores);

  if (mode === VARIANT_MODAL_MODE.CREATE) {
    const selectedStores = getMainRecipeStores(stores, recipeVariants);

    return {
      groups,
      selectedGroups: groups,
      selectedStores,
    };
  }

  if (mode === VARIANT_MODAL_MODE.MAIN_RECIPE) {
    const selectedStores = getMainRecipeStores(stores, recipeVariants);

    return {
      groups,
      selectedGroups: groups,
      selectedStores,
    };
  }

  const selectedStores = getVariantStores(stores, selectedVariant);

  return {
    groups,
    selectedGroups: getSelectedGroupsFromStores(selectedStores, groups),
    selectedStores,
  };
};
